import { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { Download, X, Smartphone, Monitor } from "lucide-react";

export const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // التحقق من أن التطبيق مثبت بالفعل
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsInstalled(true);
      return;
    }

    // الاستماع لحدث beforeinstallprompt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // إظهار الإشعار بعد 3 ثواني
      setTimeout(() => setShowPrompt(true), 3000);
    };

    // الاستماع لحدث التثبيت
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setShowPrompt(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === "accepted") {
      setIsInstalled(true);
    }
    
    setShowPrompt(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // إخفاء لمدة 24 ساعة
    localStorage.setItem("pwa-prompt-dismissed", Date.now().toString());
  };

  // التحقق من أنه تم إخفاء الإشعار مؤخراً
  useEffect(() => {
    const dismissed = localStorage.getItem("pwa-prompt-dismissed");
    if (dismissed) {
      const dayInMs = 24 * 60 * 60 * 1000;
      if (Date.now() - parseInt(dismissed) < dayInMs) {
        setShowPrompt(false);
      }
    }
  }, []);

  if (isInstalled || !showPrompt) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-in slide-in-from-bottom-4">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-4 shadow-2xl">
        <div className="flex items-start gap-3">
          {/* أيقونة */}
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center flex-shrink-0">
            <Download className="w-6 h-6 text-white" />
          </div>
          
          {/* المحتوى */}
          <div className="flex-1">
            <h3 className="font-bold text-white mb-1">
              ثبّت التطبيق على جهازك
            </h3>
            <p className="text-sm text-slate-400 mb-3">
              احصل على تجربة أفضل مع وصول سريع من الشاشة الرئيسية
            </p>
            
            {/* الأجهزة المدعومة */}
            <div className="flex items-center gap-2 mb-3">
              <div className="flex items-center gap-1 text-xs text-slate-500">
                <Smartphone className="w-3 h-3" />
                <span>الجوال</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-slate-500">
                <Monitor className="w-3 h-3" />
                <span>الكمبيوتر</span>
              </div>
            </div>
            
            {/* الأزرار */}
            <div className="flex gap-2">
              <Button
                onClick={handleInstall}
                className="bg-emerald-600 hover:bg-emerald-700 text-white flex-1"
                size="sm"
              >
                <Download className="w-4 h-4 ml-1" />
                تثبيت الآن
              </Button>
              <Button
                onClick={handleDismiss}
                variant="ghost"
                size="sm"
                className="text-slate-400 hover:text-white"
              >
                لاحقاً
              </Button>
            </div>
          </div>
          
          {/* زر الإغلاق */}
          <Button
            onClick={handleDismiss}
            variant="ghost"
            size="icon"
            className="text-slate-500 hover:text-white h-6 w-6 -mt-1 -mr-1"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
